module.exports = __webpack_public_path__ + "img/right2-mobile@3x.5e075418.png";